// Effect Managers
import { call } from 'redux-saga/effects'

// Controller
import controller from 'fc-ctrl-seasons'

// Exports
export default function *start () {
  console.info('Initializing Seasons 2.1.5')
  yield call(controller.start)
  yield call(controller.read, {
    queryParams: {
      hefty: true,
    },
  })
  yield call(controller.terminate)
}
